export const order = {
  ALL: 'Todos',
  LIST: 'Lista',
  COMPACT: 'Compacto',
  ORDER: 'Ordenar',
  ORDER_LIST: 'Lista de Ordem',
  VIEW: 'Visualizar',
  'More options for': 'Mais opções para',
};
